import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { useLang } from "@/i18n";
import { http } from "@/lib/api";
import { Reveal } from "./Primitives";

const TYPE_STYLE = { festival: "bg-[color:var(--saffron)] text-white", vrat: "bg-[color:var(--gold)]/15 text-[color:var(--gold)]", muhurat: "bg-emerald-700/10 text-emerald-800" };

export const Festivals = () => {
  const { t, lang } = useLang();
  const [st, setSt] = useState({ status: "loading", items: [] });
  useEffect(() => {
    let live = true;
    setSt({ status: "loading", items: [] });
    http.get("/festivals", { params: { lang } })
      .then((r) => live && setSt({ status: "ready", items: Array.isArray(r.data?.items) ? r.data.items : [] }))
      .catch(() => live && setSt({ status: "error", items: [] }));
    return () => { live = false; };
  }, [lang]);
  const fmt = (d) => new Intl.DateTimeFormat(lang, { day: "numeric", month: "short", weekday: "short" }).format(new Date(`${d}T12:00:00`));
  return (
    <Reveal className="mt-16" >
      <div className="card p-6 sm:p-10" data-testid="festivals-panel">
        <p className="eyebrow mb-3">{t.festivals.eyebrow}</p>
        <h3 className="display text-3xl sm:text-4xl">{t.festivals.title}</h3>
        {st.status === "loading" && <p className="mt-6 flex items-center gap-3 text-[color:var(--muted)]"><Loader2 className="w-5 h-5 animate-spin text-[color:var(--saffron)]" />{t.festivals.loading}</p>}
        {st.status === "error" && <p className="mt-6 text-[color:var(--muted)]">{t.festivals.error}</p>}
        {st.status === "ready" && (
          <ul className="mt-8 grid md:grid-cols-2 gap-x-10">
            {st.items.map((f, i) => (
              <li key={`${f.date}-${i}`} data-testid={`festival-${i}`} className="flex gap-5 py-4 border-t border-[color:var(--line)]">
                <span className="w-24 shrink-0 text-sm font-semibold text-[color:var(--saffron)]">{fmt(f.date)}</span>
                <div>
                  <p className="font-semibold">{f.name} <span className={`ml-2 align-middle text-[11px] px-2 py-0.5 rounded-full ${TYPE_STYLE[f.type] || TYPE_STYLE.vrat}`}>{t.festivals.types[f.type] || f.type}</span></p>
                  <p className="text-sm text-[color:var(--muted)] mt-1">{f.note}</p>
                </div>
              </li>
            ))}
          </ul>
        )}
        <p className="mt-6 text-xs text-[color:var(--muted)]">{t.festivals.note}</p>
      </div>
    </Reveal>
  );
};
